import { CompatibleProductTypeValues } from '@atlassian/mpac-types';
import { AtlassianProductHostingTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
export const AppListingTab = Object.freeze({
  Overview: 'overview',
  Reviews: 'reviews',
  Pricing: 'pricing',
  Support: 'support',
  Versions: 'versions',
  Installation: 'installation'
});
export const AppListingTabs = Object.keys(AppListingTab).map(key => AppListingTab[key]);
export const DEFAULT_TAB = AppListingTab.Overview;
export const CommunityTagForHostingType = {
  [AtlassianProductHostingTypeValues.Cloud]: 'cloud',
  [AtlassianProductHostingTypeValues.Server]: 'server',
  [AtlassianProductHostingTypeValues.DataCenter]: 'data-center'
};
export const HostingTypeForCompatibleProduct = {
  [CompatibleProductTypeValues.CLOUD_PRODUCT]: AtlassianProductHostingTypeValues.Cloud,
  [CompatibleProductTypeValues.SERVER_PRODUCT]: AtlassianProductHostingTypeValues.Server,
  [CompatibleProductTypeValues.DATACENTER_PRODUCT]: AtlassianProductHostingTypeValues.DataCenter
};
export const FREE_APP_CTA_LABEL_PRIMARY = 'Get it now';
export const FREE_APP_CTA_LABEL_SECONDARY = 'Free app';
export const PAID_APP_CTA_LABEL_TRY = 'Try it free';
export const PAID_APP_CTA_LABEL_START_TRIAL = 'Start free trial';
export const PAID_APP_CTA_LABEL_BUY = 'Buy it now';
export const PAID_APP_CTA_LABEL_SUBSCRIBE = 'Subscribe Now';
export const LEARN_MORE_CTA_LABEL = 'Learn more';
export const PURCHASE_CTA_LABEL = 'Purchase';
/**
 * Test ids for important elements within app listing
 */

export const TEST_ID = {
  APP_LISTING_TAB: tabName => "app-listing__tab-".concat(tabName),
  // overview
  OVERVIEW_TAB_MORE_DETAILS_CONTENT: 'app-listing__more-details-content',
  OVERVIEW_TAB_YOUTUBE_IFRAME: 'app-listing__youtube-iframe',
  OVERVIEW_TAB_HERO_HIGHLIGHTS: 'hero-and-highlights-container',
  OVERVIEW_TAB_HERO_IMAGE: 'app-listing__hero-img',
  OVERVIEW_TAB_HIGHLIGHT_SUMMARY: 'app-listing__highlight-summary',
  OVERVIEW_TAB_HIGHLIGHT_IMAGE: 'app-listing__highlight-img',
  // overview tab -> Resources section -> cloud migration subsection
  CLOUD_MIGRATION_ALTERNATE_APP: 'cloud-migration__alternate-app',
  CLOUD_MIGRATION_MIGRATION_DOCUMENTATION: 'cloud-migration__migration-documentation',
  CLOUD_MIGRATION_FEATURE_DIFFERENCE: 'cloud-migration__feature-difference',
  // support
  SUPPORT_TAB_EMAIL_ID: 'app-listing__support-link__email-id',
  SUPPORT_TAB_PHONE_NUMBER: 'app-listing__support-link__phone-number',
  SUPPORT_TAB_STATUS_PAGE_URL: 'app-listing__support-link__status-page-url',
  SUPPORT_TAB_SUPPORT_TIMINGS: 'app-listing__support-contact__availability-timings',
  // pricing
  PRICING_TAB_VIEW_ADDITIONAL_PRICING: 'app-listing__pricing-tab-view-additional-pricing',
  PRICING_TAB_INSTALL_CTA: 'app-listing__pricing-tab__install-cta',
  // installation
  INSTALLATION_TAB_STEP_SCREENSHOT: 'app-listing__installation-step-screenshot',
  // cta
  CTA_INSTALL_APP_BTN: 'app-listing__install-app-btn',
  // hosting selector
  HOSTING_SELECTOR_MODAL_REQUEST_APP: 'hosting-selector-modal__request-app-btn',
  HOSTING_SELECTOR_MODAL_COLUMN_CLOUD: 'hosting-selector-modal__column-cloud',
  HOSTING_SELECTOR_MODAL_COLUMN_SERVER: 'hosting-selector-modal__column-server',
  HOSTING_SELECTOR_MODAL_COLUMN_DATACENTER: 'hosting-selector-modal__column-datacenter'
};
export const ELEMENT_ID = {
  CLOUD_MIGRATION_SECTION_LINKS: 'app-listing__cloud-migration-links'
};
/** Minumum number of fractional digits to use when representing the price in PUP */

export const PER_USER_PRICING_FORMAT_MIN_FRACTION_DIGITS = 2;